import React, { useState } from 'react';
import './App.css';
import { translations } from './translations';
import Navbar from './components/Navbar/Navbar';
import Hero from './components/Hero/Hero';
import About from './components/About/About';
import WhyChoose from './components/WhyChoose/WhyChoose';
import Tours from './components/Tours/Tours';
import Gallery from './components/Gallery/Gallery';
import Testimonials from './components/Testimonials/Testimonials';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';

function App() {
  const [language, setLanguage] = useState('en');

  const toggleLanguage = () => {
    setLanguage(language === 'en' ? 'fr' : 'en');
  };

  const t = translations[language];

  return (
    <div className="App">
      <Navbar language={language} toggleLanguage={toggleLanguage} t={t.nav} />
      <Hero t={t.hero} />
      <About t={t.about} />
      <WhyChoose t={t.whyChoose} />
      <Tours t={t.tours} />
      <Gallery t={t.gallery} />
      <Testimonials t={t.testimonials} />
      <Contact t={t.contact} />
      <Footer t={t.footer} />
    </div>
  );
}

export default App;
